import React from 'react';
import { routes, faqConstants } from '../constants';
import { connect } from 'react-redux';
import { RouteActions, FAQActions } from '../actions';
import { Card, SearchBar, Column, Columns, DynamicContent, SearchText, SearchButton } from '../components';

class FAQPage extends React.Component {
    constructor(props){
        super(props);

        this.state = {
            search: {
                text: ''
            }
        }

        this.filter = this.filter.bind(this);
    }

    componentDidMount() {
        this.props.dispatch(RouteActions.setAppState(routes.FAQ));

        //Load FAQs
        this.props.dispatch(FAQActions.resetFAQ());
        this.props.dispatch(FAQActions.addFaq(faqConstants.defaultFAQs));
    }

    filter(result){
        this.setState({
            search: result
        });
    }

    render() {
        const searchHandler = (res) => {
            this.filter(res);
        }

        const faqTemplate = (item, i) => {
            let createMarkup = (item) => {
                return {
                    __html: item.answer
                }
            }
            let text = this.state.search.text || '';
            let needle = text.toLowerCase();
            let haystack = item.question.toLowerCase();
            let shouldRender = haystack.indexOf(needle) != -1 || needle.length <= 0;

            if (!shouldRender) {
                return null;
            } else {
                return (
                    <Card key={i}>
                        <h4 className="faq-question" dangerouslySetInnerHTML={{__html: item.question}}></h4>
                        <DynamicContent className="faq-answer" dangerouslySetInnerHTML={createMarkup(item)}></DynamicContent>
                    </Card>
                )
            }
        }

        return (
            <div id="faq-page" className="container">
                <div className="row center-cols">
                    <div className="col-sm-8 page-header">
                        <h1 className="page-title">Frequently Asked Questions</h1>
                        <SearchBar autoSearch="true" className="faq-search" placeholder="Filter" onSearch={searchHandler}>
                            <SearchText className="faq-search-text" name="text" />
                            <SearchButton className="primary" />
                        </SearchBar>
                    </div>
                </div>
                <Columns className="row" list={this.props.faqs}>
                    <Column className="col-sm-6" template={faqTemplate} />
                    <Column className="col-sm-6" template={faqTemplate} />
                </Columns>
            </div>
        );
    }
}

function select(state) {
    return {
        appState: state.appState.currentRoute,
        faqs: state.faqList
    }
}

export default connect(select)(FAQPage);



// WEBPACK FOOTER //
// ./web-app/containers/faq.jsx